import React from 'react';
import styled from 'styled-components';
import InitialLoading from 'components/InitialLoading';


const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  min-height: 90vh;
  justify-content: center;
  width: 100%;
`;

const LoadingComponent = () => {
  return (
    <CenterContainer><InitialLoading mounted={true} transparent={false} /></CenterContainer>
  );
};

export default LoadingComponent;